import moment from 'moment'
import { calculateServerRouting } from '../api'
import { AvoidSetting } from './avoid-setting'
import { TruckSetting } from './truck-setting'
import { Waypoint } from './waypoints'
import { parseServerRoutingResp } from './route'

export class ServerRoutePlan {
  constructor(truckSetting, avoidSetting, transportMode) {
    this.truckSetting = truckSetting
    this.avoidSetting = avoidSetting
    this.routingMode = 'fastest'
    this.transportMode = transportMode
    this.waypoints = []
    this.alternatives = null
    this.departureTime = null
    this.routeDescription = '' // userId_时间戳(毫秒)，用于统计
  }
  addWaypoint(waypoint) {
    this.waypoints.push(waypoint)
  }
  getRoute(cancelToken) {
    const routeOption = {
      departureTime: moment(this.departureTime).format('X'), // 以秒为单位的时间戳
      routingMode: this.transportMode,
      resultLimit: this.alternatives,
      routingType: this.routingMode,
      routingOption: this.avoidSetting.toQueryParams()
    }
    const params = {
      routeDescription: this.routeDescription,
      isNavigation: 0,
      wayPoints: this.waypoints.map(item => item.toQueryParamString()),
      routeOption
    }
    if (this.transportMode === ServerRoutePlan.TRANSPORT_MODE.TRUCK) {
      routeOption.speedProfile = 'fast'
      routeOption.truckModel = this.truckSetting.toQueryParams()
    }
    return calculateServerRouting(params, cancelToken).then(res => parseServerRoutingResp(JSON.parse(res.data), res.responseHeaders))
  }
  static fromFleetParams(params) {
    let more = null
    let setting = []
    let routeSetting = params.routeSetting || []
    // truck mode
    if (params.mode === 'truck') {
      more = ServerRoutePlan.TRANSPORT_MODE.TRUCK
      setting = routeSetting
    } else {
      more = ServerRoutePlan.TRANSPORT_MODE.CAR
      // Avoiding difficult turns is only supported for transport mode `truck`
      setting = routeSetting.filter(item => item !== 'harshTurn')
    }
    // avoid setting
    const avoidSetting = new AvoidSetting(setting)
    // truck setting
    const truckSetting = new TruckSetting(params)
    
    const serverRoutePlan = new ServerRoutePlan(truckSetting, avoidSetting, more)
    serverRoutePlan.alternatives = params.alternatives || 1
    serverRoutePlan.departureTime = params.departure || new Date()
    serverRoutePlan.routeDescription = params.routeDescription || ''

    // Waypoints
    let waypoint = params.wayPoints
    for (let i = 0; i < waypoint.length; i++) {
      serverRoutePlan.addWaypoint(new Waypoint(i, waypoint[i]))
    }
    return serverRoutePlan
  }
}
ServerRoutePlan.TRANSPORT_MODE = {
  TRUCK: 'truck',
  CAR: 'car',
}